import image from "fragments/image"
import gql from "graphql-tag"

const screenshot = gql`
  ${image}

  fragment Screenshot on Image {
    ...Image
    credit
  }
`

export default screenshot
